export default { "columns":5,
 "image":"mushroom_tileset.png",
 "imageheight":128,
 "imagewidth":80,
 "margin":0,
 "name":"mushroom_tileset",
 "spacing":0,
 "tilecount":40,
 "tiledversion":"1.11.0",
 "tileheight":16,
 "tiles":[
        {
         "id":0,
         "type":"ground"
        }, 
        {
         "id":1,
         "type":"ground"
        }, 
        {
         "id":2,
         "type":"ground"
        }, 
        {
         "id":3,
         "type":"ground"
        }, 
        {
         "id":4,
         "type":"ground"
        }, 
        {
         "id":5,
         "type":"ground"
        }, 
        {
         "id":6,
         "type":"ground"
        }, 
        {
         "id":7,
         "type":"ground"
        }, 
        {
         "id":8,
         "type":"ground"
        }, 
        {
         "id":9,
         "type":"ground"
        }, 
        {
         "id":10,
         "type":"ground"
        }, 
        {
         "id":11,
         "type":"ground"
        }, 
        {
         "id":12,
         "type":"ground"
        }, 
        {
         "id":13,
         "type":"decal"
        }, 
        {
         "id":14,
         "type":"decal"
        }, 
        {
         "id":15,
         "type":"platform"
        }, 
        {
         "id":16,
         "type":"platform"
        }, 
        {
         "id":17,
         "type":"platform"
        }, 
        {
         "id":18,
         "type":"platform"
        }, 
        {
         "id":20,
         "type":"platform"
        }, 
        {
         "id":21,
         "type":"platform"
        }, 
        {
         "id":22,
         "type":"platform"
        }, 
        {
         "id":23,
         "type":"platform"
        }, 
        {
         "id":25,
         "type":"decal"
        }, 
        {
         "id":26,
         "type":"decal"
        }, 
        {
         "id":27,
         "type":"decal"
        }, 
        {
         "id":28,
         "type":"decal"
        }, 
        {
         "id":30,
         "type":"decal"
        }, 
        {
         "id":31,
         "type":"decal"
        }, 
        {
         "id":32,
         "type":"decal"
        }, 
        {
         "id":33,
         "type":"decal"
        }, 
        {
         "id":35,
         "type":"decal"
        }, 
        {
         "id":36,
         "type":"decal"
        }, 
        {
         "id":37,
         "type":"decal"
        }, 
        {
         "id":38,
         "type":"decal"
        }, 
        {
         "id":39,
         "type":"decal"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};